import { styled } from 'styled-components'
import { Button } from '~/shared/ui/Buttons'
import { myPalette } from '~/shared/ui/theme'
import { WhiteBlock } from '~/shared/ui/Wrappers'

export const SignButton = styled(Button)`
  position: absolute;
  bottom: 24px;
  padding: 0;
  left: 12px;
  right: 12px;
  width: auto;
`

export const FileButton = styled(Button)`
  width: 126px;
  height: 72px;
`

export const RentalContractWrapper = styled(WhiteBlock)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const AlertWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 24px;
`

export const AlertIcon = styled.div`
  margin-top: 4px;
`

export const AlertDescriptions = styled.div`
  font-size: 16px;
  margin-left: 10px;
`

export const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 18px;
  margin-bottom: 6px;
`

export const CreatedAd = styled.div`
  font-size: 14px;
  color: ${myPalette.mutedText.main};
`
